import { useState, useEffect } from "react";
import { Image, Spin, Empty, Typography, Col, Row } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import API from "../../utils/API"

const { Text } = Typography;

export default function AppointmentImages(props) {
    const { images } = props
    const [displayImages, setDisplayImages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const imageKeys = images?.map(img => img.key).join(",");
    useEffect(() => {
        if (!imageKeys) return;
        const fetchImages = async () => {
            setIsLoading(true);
            try {
                const res = await API.post(`/api/appointments/get-images`, {
                    images: imageKeys
                });
                setDisplayImages(res.data.images || []);
            } catch (err) {
                console.error("Error fetching images:", err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchImages();
    }, [imageKeys]); // ✅ primitive string — stable reference



    if (isLoading) {
        return (
            <div className="flex justify-center py-6">
                <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
            </div>
        );
    }



    if (!images.length) {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<Text type="secondary">No photos uploaded</Text>}
                className="py-4"
            />
        );
    }

    return (
        <div style={{ overflow: "hidden" }}>
            <Row justify="center" gutter={8}>
                {/* <div style={{ display: "flex", gap: 10 }}> */}
                <Image.PreviewGroup>
                    {displayImages.map((img) => (
                        <Col
                            key={img._id || img.key}
                            style={{
                                position: "relative",
                                width: 80,
                                height: 80,
                                flexShrink: 0,
                                margin: "3px 3px"
                            }}
                        >
                            <Image
                                src={img.url}
                                alt="Appointment photo"
                                width={80}
                                height={80}
                                style={{
                                    objectFit: "cover",
                                    borderRadius: "5px",
                                }}
                                placeholder={
                                    <div
                                        style={{
                                            width: 80,
                                            height: 80,
                                        }}
                                    >
                                        <Spin indicator={<LoadingOutlined spin />} />
                                    </div>
                                }
                            />


                        </Col>

                    ))}

                </Image.PreviewGroup>
                {/* </div> */}

            </Row>
        </div >
    );
}